import { styled } from '@mui/material';
import TabList from '@mui/lab/TabList';

export const VyTabList = styled(TabList)({
  display: 'flex',
  gap: '20px',
  alignItems: 'center',
  '& .MuiTab-root': {
    fontSize: 14,
    fontWeight: 400,
    color: '#7E8796',
  },
  '& .MuiTabPanel-root': {
    padding: '33px',
  },
  '& .Mui-selected': {
    color: '#020F20',
  },
});
